import { ActionIcon, Box, Stack, Text } from "@mantine/core";
import { IconArrowBarDown, IconArrowBarToUp, IconBrain } from "@tabler/icons-react";
import ActionButton from "../ActionButton";
import ChatMarkdown from "../ChatMarkdown";
import classes from "./SharedItem.module.css";
import type { ItemViewProps } from "./types";

export const ICON_SIZE = 32;

export function ReasoningItemView({
    item,
    opened,
    onOpen,
    onClose,
    actionButtons,
    containerClassName,
    showActions = true,
    containerRef,
}: ItemViewProps) {
    return (
        <Box className={`${classes.container} ${containerClassName ?? ""}`} ref={containerRef}>
            {showActions && (
                <ActionIcon.Group className={classes.icons}>
                    {item.context && (
                        <>
                            {!opened && (
                                <ActionButton
                                    onClick={onOpen}
                                    label="Show content"
                                    icon={<IconArrowBarDown stroke={1} />}
                                />
                            )}
                            {opened && (
                                <ActionButton
                                    onClick={onClose}
                                    label="Hide content"
                                    icon={<IconArrowBarToUp stroke={1} />}
                                />
                            )}
                        </>
                    )}
                    {actionButtons}
                </ActionIcon.Group>
            )}
            <Box>
                <IconBrain size={ICON_SIZE} />
            </Box>
            <Box className={classes.content}>
                {opened ? (
                    (item.reasoningSummary ?? []).length === 0 ? (
                        <Text c="dimmed">Reasoning summary not available</Text>
                    ) : (
                        <Stack>
                            {(item.reasoningSummary ?? []).map((s, i) => (
                                <ChatMarkdown key={i} content={s} />
                            ))}
                        </Stack>
                    )
                ) : (
                    <Box>REASONING</Box>
                )}
            </Box>
        </Box>
    );
}
